import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Garante que toda navegação (inclusive links do rodapé) carregue a página no topo.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
